<template>
  <div class="side-menu" @click.self="$emit('close')">
    <div class="side-menu-header">
      <span class="side-menu-title">예제 프롬프트</span>
      <button class="close-btn" @click="$emit('close')">×</button>
    </div>
    <div class="side-menu-list">
      <button
          v-for="(mission, i) in missions"
          :key="i"
          class="side-menu-mission-btn"
          @click="selectMission(i)"
          :class="{ selected: selectedMission === i }"
      >
        {{ mission.title }}
      </button>
    </div>
    <div v-if="selectedMission !== null" class="side-menu-detail">
      <div class="mission-desc-mobile">
        <p><strong>설명:</strong> {{ missions[selectedMission].description }}</p>
        <p><strong>예시 프롬프트:</strong></p>
        <code>{{ missions[selectedMission].examplePrompt }}</code>
        <button class="example-prompt-btn" @click="applyPrompt">예시 프롬프트 사용</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
const props = defineProps({
  missions: {
    type: Array,
    required: true
  }
});
const emit = defineEmits(['select', 'close']);
const selectedMission = ref(null);
const selectMission = (i) => {
  selectedMission.value = i;
};
const applyPrompt = () => {
  if (selectedMission.value !== null) {
    emit('select', props.missions[selectedMission.value].examplePrompt);
    emit('close');
    selectedMission.value = null;
  }
};
</script>

<style scoped>
.side-menu {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: #f9fafb;
  box-shadow : 2px 0 8px rgba(0,0,0,0.06);
  border-right : 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
}

.side-menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  height : 50px;
}
.side-menu-title {
  height: 100%;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.2;
  align-items : center;
  display: flex;
}
.close-btn {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: #64748b;
  padding: 0.5rem;
  cursor: pointer;
}

/* 세로 정렬.. 자리 너무 차지..가로 정렬로 바꿔보자
.side-menu-list {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 1rem 0.5rem;
}
*/

.side-menu-list {
  display: flex;
  flex-direction : row;
  flex-wrap : wrap;
  gap: 0.5rem;
  padding : 1rem;
}


.side-menu-mission-btn {
  width: fit-content;
  background: #f1f5f9;
  color: #374151;
  border: none;
  border-radius: 9999px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.04);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.side-menu-mission-btn.selected,
.side-menu-mission-btn:hover {
  background: #2563eb;
  color: #fff;
}

.side-menu-detail {
  padding: 1rem;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}
.mission-desc-mobile {
  background: #ffffff;
  padding: 0.75rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  font-size: 0.92rem;
  color: #374151;
  line-height: 1.6;
  margin-top: 0.75rem;
}
.mission-desc-mobile p {
  margin-bottom: 0.5rem;
}
.mission-desc-mobile code {
  display: block;
  background: #f3f4f6;
  padding: 0.6rem;
  border-radius: 0.4rem;
  font-size: 0.85rem;
  white-space: pre-wrap;
  color: #1f2937;
}
.example-prompt-btn {
  display: inline-block;
  margin-top: 0.5rem;
  padding: 0.35rem 1rem;
  font-size: 0.85rem;
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.2s;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.08);
}
.example-prompt-btn:hover {
  background: #1d4ed8;
}

@media (max-width: 480px) {
  .side-menu-detail {
    padding: 0.5rem;
  }
  .mission-desc-mobile {
    font-size: 0.88rem;
    padding: 0.5rem;
  }
  .mission-desc-mobile code {
    font-size: 0.8rem;
    padding: 0.4rem;
  }
}
</style>





<!--<template>-->
<!--  <div class="side-menu" @click.self="$emit('close')">-->
<!--    <div class="side-menu-header">-->
<!--      <span class="side-menu-title">예제 프롬프트</span>-->
<!--      <button class="close-btn" @click="$emit('close')">×</button>-->
<!--    </div>-->
<!--    <div class="side-menu-list">-->
<!--      <button-->
<!--        v-for="(mission, i) in missions"-->
<!--        :key="i"-->
<!--        class="side-menu-mission-btn"-->
<!--        @click="selectMission(i)"-->
<!--        :class="{ selected : selectedMission === i}"-->
<!--        >-->
<!--        {{mission.title}}-->
<!--      </button>-->
<!--    </div>-->
<!--    <div v-if="selectedMission !== null" class="side-menu-detail">-->
<!--      <div class="mission-desc-mobile">-->
<!--        <p><strong>설명:</strong> {{ missions[selectedMission].description }}</p>-->
<!--        <p><strong>예시 프롬프트:</strong></p>-->
<!--        <code>{{ missions[selectedMission].examplePrompt }}</code>-->
<!--        <button class="example-prompt-btn" @click="applyPrompt">예시 프롬프트 사용</button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->

<!--<script setup>-->
<!--import {ref, defineProps, defineEmits} from 'vue';-->
<!--const props = defineProps({-->
<!--  missions: {-->
<!--    type: Array,-->
<!--    required: true-->
<!--  }-->
<!--});-->
<!--const emit = defineEmits(['select', 'close']);-->
<!--const selectedMission = ref(null);-->
<!--const selectMission = (i) => {-->
<!--  selectedMission.value = i;-->
<!--};-->
<!--const applyPrompt = () => {-->
<!--  if (selectedMission.value !== null) {-->
<!--    emit('select', props.missions[selectedMission.value].examplePrompt);-->
<!--    emit('close');-->
<!--    selectedMission.value = null;-->
<!--  }-->
<!--};-->
<!--</script>-->
<!--<style scoped>-->
<!--.side-menu {-->
<!--  position: fixed;-->
<!--  left: 0;-->
<!--  top: 0;-->
<!--  bottom: 0;-->
<!--  width: 65vw;-->
<!--  max-width: 340px;-->
<!--  background: #fff;-->
<!--  z-index: 10001;-->
<!--  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);-->
<!--  animation: slideIn 0.3s;-->
<!--  overflow-y: auto;-->
<!--  overflow-x: hidden;-->
<!--  display: flex;-->
<!--  flex-direction: column;-->
<!--}-->
<!--@keyframes slideIn {-->
<!--  from {transform: translateX(-100%);-->
<!--  }-->
<!--  to {transform: translateX(0);-->
<!--  }-->
<!--}-->
<!--.side-menu-header {-->
<!--  display: flex;-->
<!--  align-items: center;-->
<!--  justify-content: space-between;-->
<!--  padding: 1rem;-->
<!--  border-bottom: 1px solid #e5e7eb;-->
<!--  background: #f8fafc;-->
<!--}-->
<!--.side-menu-title {-->
<!--  font-size: 1.1rem;-->
<!--  font-weight: 600;-->
<!--}-->
<!--.close-btn {-->
<!--  background: transparent;-->
<!--  border: none;-->
<!--  font-size: 1.5rem;-->
<!--  color: #64748b;-->
<!--  padding: 0.5rem;-->
<!--  cursor: pointer;-->
<!--}-->
<!--.side-menu-list {-->
<!--  display: flex;-->
<!--  flex-direction: column;-->
<!--  gap: 0.7rem;-->
<!--  padding: 1rem 0.5rem;-->
<!--}-->
<!--.side-menu-mission-btn {-->
<!--  width: 100%;-->
<!--  background: #f1f5f9;-->
<!--  color: #2563eb;-->
<!--  border: none;-->
<!--  border-radius: 9999px;-->
<!--  padding: 0.9rem 1.2rem;-->
<!--  font-size: 1rem;-->
<!--  font-weight: 600;-->
<!--  margin: 0;-->
<!--  text-align: left;-->
<!--  cursor: pointer;-->
<!--  transition: background 0.18s, color 0.18s;-->
<!--  box-shadow: 0 1px 2px rgba(37,99,235,0.04);-->
<!--}-->
<!--.side-menu-mission-btn.selected,-->
<!--.side-menu-mission-btn:hover {-->
<!--  background: #2563eb;-->
<!--  color: #fff;-->
<!--}-->

<!--.side-menu-detail {-->
<!--  padding: 1rem;-->
<!--  border-top: 1px solid #e5e7eb;-->
<!--  background: #f9fafb;-->
<!--}-->
<!--.mission-desc-mobile {-->
<!--  background: #ffffff;-->
<!--  padding: 0.75rem;-->
<!--  border-radius: 0.5rem;-->
<!--  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);-->
<!--  font-size: 0.92rem;-->
<!--  color: #374151;-->
<!--  line-height: 1.6;-->
<!--  margin-top: 0.75rem;-->
<!--}-->
<!--.mission-desc-mobile p {-->
<!--  margin-bottom: 0.5rem;-->
<!--}-->
<!--.mission-desc-mobile code {-->
<!--  display: block;-->
<!--  background: #f3f4f6;-->
<!--  padding: 0.6rem;-->
<!--  border-radius: 0.4rem;-->
<!--  font-size: 0.85rem;-->
<!--  white-space: pre-wrap;-->
<!--  color: #1f2937;-->
<!--}-->
<!--.example-prompt-btn {-->
<!--  display: inline-block;-->
<!--  margin-top: 0.5rem;-->
<!--  padding: 0.35rem 1rem;-->
<!--  font-size: 0.85rem;-->
<!--  background: #2563eb;-->
<!--  color: #fff;-->
<!--  border: none;-->
<!--  border-radius: 999px;-->
<!--  cursor: pointer;-->
<!--  transition: background 0.2s;-->
<!--  font-weight: 500;-->
<!--  box-shadow: 0 1px 2px rgba(37, 99, 235, 0.08);-->
<!--}-->
<!--.example-prompt-btn:hover {-->
<!--  background: #1d4ed8;-->
<!--}-->
<!--@media (max-width: 480px) {-->
<!--  .side-menu {-->
<!--    width: 95vw;-->
<!--  }-->
<!--  .side-menu-detail {-->
<!--    padding: 0.5rem;-->
<!--  }-->
<!--  .mission-desc-mobile {-->
<!--    font-size: 0.88rem;-->
<!--    padding: 0.5rem;-->
<!--  }-->
<!--  .mission-desc-mobile code {-->
<!--    font-size: 0.8rem;-->
<!--    padding: 0.4rem;-->
<!--  }-->
<!--}-->

<!--.mission-tabs-mobile label.selected {-->
<!--  background : #3b82f6;-->
<!--  color:#fff;-->
<!--  border-color:#2563eb;-->
<!--}-->
<!--</style>-->